var theme = {
  color: {
    primary: {
      DEFAULT: '#0ea5e9',
      bg: '#f0f9ff',
      'bg-hover': '#e0f2fe',
      border: '#bae6fd',
      'border-hover': '#7dd3fc',
      hover: '#38bdf8',
      active: '#0284c7',
      text: '#0ea5e9',
      'text-hover': '#38bdf8',
      'text-active': '#0284c7'
    },
    success: {
      DEFAULT: '#10ba81',
      bg: '#e1faed',
      'bg-hover': '#adedcf',
      border: '#80e0b7',
      'border-hover': '#57d4a2',
      hover: '#32c790',
      active: '#069469',
      text: '#10ba81',
      'text-hover': '#32c790',
      'text-active': '#069469'
    },
    warning: {
      DEFAULT: '#f97316',
      bg: '#fff7ed',
      'bg-hover': '#ffedd5',
      border: '#fed7aa',
      'border-hover': '#fdba74',
      hover: '#f97316',
      active: '#ea580c',
      text: '#f97316',
      'text-hover': '#f97316',
      'text-active': '#ea580c'
    },
    error: {
      DEFAULT: '#ef4343',
      bg: '#fff2f0',
      'bg-hover': '#ffedeb',
      border: '#ffc8c2',
      'border-hover': '#ffa099',
      hover: '#fc746f',
      active: '#c92e34',
      text: '#ef4343',
      'text-hover': '#fc746f',
      'text-active': '#c92e34'
    },
    info: {
      DEFAULT: '#0ea5e9',
      bg: '#f0f9ff',
      'bg-hover': '#e0f2fe',
      border: '#bae6fd',
      'border-hover': '#7dd3fc',
      hover: '#38bdf8',
      active: '#0284c7',
      text: '#0ea5e9',
      'text-hover': '#38bdf8',
      'text-active': '#0284c7'
    },
    middle: {
      'text-base': '#000',
      'bg-base': '#fff',
      text: 'var(--color-text-1)',
      subtext: 'var(--color-text-2)',
      'text-1': 'rgba(0, 0, 0, 0.85)',
      'text-2': 'rgba(0, 0, 0, 0.65)',
      'text-3': 'rgba(0, 0, 0, 0.45)',
      'text-4': 'rgba(0, 0, 0, 0.25)',
      'text-disabled': '#d9d9d9',
      border: 'var(--color-border-1)',
      'border-1': '#d9d9d9',
      'border-2': '#f0f0f0',
      fill: 'var(--color-fill-1)',
      'fill-1': 'rgba(0, 0, 0, 0.15)',
      'fill-2': 'rgba(0, 0, 0, 0.06)',
      'fill-3': 'rgba(0, 0, 0, 0.04)',
      'fill-4': 'rgba(0, 0, 0, 0.02)',
      shadow: 'rgba(0, 0, 0, 0.15)',
      'shadow-light': 'rgba(0, 0, 0, 0.1)',
      'bg-container': '#fff',
      'bg-container-light': '#fafafa',
      'bg-popover': '#fff',
      'bg-layout': '#f5f5f5',
      'bg-spotlight': 'rgba(0, 0, 0, 0.85)',
      'bg-mask': 'rgba(0, 0, 0, 0.45)',
      'bg-hover': 'rgba(0, 0, 0, 0.06)',
      'bg-disabled': '#f5f5f5',
      'bg-side': '#fff',
      'bg-header': '#fff',
      'bg-menu': '#fff',
      'bg-submenu': '#fafafa'
    }
  },
  padding: {
    base: '4px',
    default: '16px',
    xxs: '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px'
  },
  margin: {
    base: '4px',
    default: '16px',
    xxs: '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px'
  },
  font: {
    'font-size': '14px',
    'font-size-xs': '10px',
    'font-size-sm': '12px',
    'font-size-md': '14px',
    'font-size-lg': '16px',
    'font-size-xl': '18px',
    'font-size-xxl': '22px',
    'font-size-xxxl': '30px',
    leading: '1.5714285714285714',
    'leading-sm': '1.6666666666666667',
    'leading-lg': '1.5',
    'leading-head-1': '1.2105263157894737',
    'leading-head-2': '1.2666666666666666',
    'leading-head-3': '1.3333333333333333',
    'leading-head-4': '1.4',
    'leading-head-5': '1.5'
  },
  shadow: {
    'box-shadow-1': '0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)',
    'box-shadow-2': '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
    'box-shadow-3': '0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03)'
  },
  radius: {
    'radius-base': '2px',
    'radius-xs': '2px',
    'radius-sm': '4px',
    'radius-md': '6px',
    'radius-lg': '8px'
  },
  size: {
    'width-side': '220px',
    'width-side-collapsed': '64px',
    'height-header': '56px',
    'height-footer': '56px'
  }
};
export default theme;